import mixins from 'synergycms_core/src/less/mixins';

export default {
  invalid: {},
  inputText: {
    padding: '15px 0 0 15px',
    color: '#000',
    width: '100%',
    height: '40px',
    background: 'transparent',
    border: '1px solid #d8d8d8',
    ...mixins.transition(),
    ...mixins.boxShadow('0 0 7px -2px rgba(0, 0, 0, 0.5)'),
    ...mixins.boxSizing(),
    '&$invalid': {
      marginBottom: '7px',
      borderColor: '#d0021b',
      display: 'block',
      color: '#d0021b'
    },
    '&:lang(ar)': {
      paddingRight: '15px',
      paddingLeft: 0
    }
  }
};
